import ApiService from '@/utils/ApiService'
import getIdFromLink from '@/utils/getIdFromLink'

export default {
  namespaced: true,
  state: {
    error: '',
    isLoading: false,
    items: [],
    view: [],
    userDataOptions: [],
    itemOptions: [],
    sendSurveyToContractorId: null,
    isSendSurveyToContractorModalVisible: false
  },
  getters: {
    error: (state) => state.error,
    isLoading: (state) => state.isLoading,
    items: (state) => state.items,
    view: (state) => state.view,
    getSendSurveyToContractorId: state => state.sendSurveyToContractorId,
    getIsSendSurveyToContractorModalVisible: state => state.isSendSurveyToContractorModalVisible
  },
  mutations: {
    setError (state, error) {
      state.error = error
    },
    toggleLoading (state) {
      state.isLoading = !state.isLoading
    },
    setItems (state, items) {
      state.items = items
    },
    setView (state, view) {
      state.view = view
    },
    toggleSendSurveyToContractorModal (state) {
      state.isSendSurveyToContractorModalVisible = !state.isSendSurveyToContractorModalVisible
    },
    setSendSurveyToContractorId (state, payload) {
      state.sendSurveyToContractorId = payload
    }
  },
  actions: {
    async getItems ({ commit }, url = 'e_x_a_b_surveys') {
      commit('toggleLoading')
      const response = await new ApiService(url).getResults()
      commit('setItems', await response.items)
      commit('setView', await response.view)
      commit('toggleLoading')
    },
    async sendSurveyToContractor ({ commit, state }, params) {
      await new ApiService(`e_x_a_b_surveys/${getIdFromLink(state.sendSurveyToContractorId)}/sendsurveytocontractor`).post(params)
      commit('toggleSendSurveyToContractorModal')
    }
  }
}
